import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
function BottomBanner() {
    const { t } = useTranslation();
    return ( 
        <>
          {/* Join Movement */}
          <section className="text-center bg-[#3bb18f] text-white p-8">
            <h2 className="text-3xl font-bold mb-4">{t('joinMovementDescription')}</h2>
            
            <Link 
                to="/app-download" 
                className="inline-block px-8 py-4 bg-white text-[#3bb18f] rounded-lg hover:bg-gray-100 transition-colors duration-300 text-xl font-semibold"
            >
                {t('getStarted')}
            </Link>
          </section>
        </>
     );
}

export default BottomBanner;